<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Event Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editEvent">Edit Event</button>
                </div>
            </div>
            <div class="table-responsive" v-if="event">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{event.eventId}}</td>
                    </tr>
                    <tr>
                        <th>Title</th>
                        <td>{{event.title}}</td>
                    </tr>
                    <tr>
                        <th>description</th>
                        <td>{{event.description}}</td>
                    </tr>
                    <tr>
                        <th>Long Description</th>
                        <td>{{event.longDescription}}</td>
                    </tr>
                    <tr>
                        <th>Start Date</th>
                        <td>{{event.start_date}}</td>
                    </tr><tr>
                    <th>End Date</th>
                    <td>{{event.end_date}}</td>
                </tr>
                    <tr>
                        <th>Chatroll Event Id</th>
                        <td>{{event.chatroll_event_id}}</td>
                    </tr><tr>
                    <th>Chatroll Event Name</th>
                    <td>{{event.chatroll_event_name}}</td>
                </tr>
                    <tr>
                        <th>Duration</th>
                        <td>{{event.duration}}</td>
                    </tr><tr>
                    <th>Expert Name(s)</th>
                    <td v-if="event">{{event.csvExpertsNames}}</td>
                </tr>
                    <tr>
                        <th class="align-content-center">Image</th>
                        <td><img :src="event.img_url" alt="event-image" class="detail-thumbnail"></td>
                    </tr>
                    <tr>
                        <th>Jw Rtmp Url</th>
                        <td>{{event.jw_rtmp_url}}</td>
                    </tr><tr>
                    <th>Video Code</th>
                    <td>{{event.jw_stream_title}}</td>
                </tr>
                  <tr>
                    <th>Switch Time (Minutes)</th>
                    <td v-if="event.eventSwitchTime">{{event.eventSwitchTime}}</td>
                  </tr>
                  <tr>
                    <th>Tags</th>
                    <td>{{event.tags}}</td>
                  </tr>
                  <tr>
                    <th>Has Archive Playlist?</th>
                    <td v-if="event.toneLive == '1'">Yes</td><td v-else>No</td>
                  </tr>
                  <tr>
                  <tr>
                    <th>Corporation</th>
                    <td>{{event.corporationName}}</td>
                  </tr>
                  <tr>
                    <th>Is Private?</th>
                    <td><span v-if="event.isPrivate === 1">Yes</span><span v-else>No</span></td>
                  </tr>
                  <tr>
                    <th>Enable Corporate Archiving?</th>
                    <td><span v-if="event.corporateEventArchive === 1">Yes</span><span v-else>No</span></td>
                  </tr>
                  <tr>
                    <th>Type</th>
                    <td v-if="event.type == '1'">Live Event</td>
                    <td v-if="event.type == '2'">Talk Event</td>
                    <td v-if="event.type == '3'">Corporation self-hosted Event</td>
                  </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="event.status == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewEvent',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.id).then(() =>{
            this.event = this.selectedEvent;
            this.event.expert = this.getExpert(this.event.expertId);
        })

    },
    data () {
        return {
            event: {}
        }
    },
    methods: {
        editEvent(){
            this.$router.push({ name: 'EditEvent', params: { id: this.event.eventId}})
        },
    },
    computed: {...mapGetters([
        'selectedEvent', 'getExpert'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Events/EventDetails.vue